<template>
    <div class="works-stats-content card-box-style rounded">
        <div class="main-title border-style d-flex justify-content-between align-items-center">
            <h3>Works Stats</h3>

            <select class="form-select form-control" aria-label="Default select example">
                <option selected>Today</option>
                <option value="1">16 days</option>
                <option value="2">17 days</option>
                <option value="3">18 days</option>
            </select>
        </div>

        <div class="works-chart text-center">
            <apexchart type="donut" height="305" :options="worksChart" :series="series"></apexchart>
        </div>

        <div class="row justify-content-center">
            <div 
                class="col-lg-4 col-sm-4"
                v-for="work in works"
                :key="work.id"
            >
                <div class="single-works">
                    <span class="title">{{work.title}}</span>
                    <h4>{{work.hours}}{{work.number}} <span>{{work.percent}}</span></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import worksStats from './worksStats.json'

export default {
    name: 'WorksStats',
    data: function() {
        return {
            works: worksStats,
            series: [50, 20, 15],
            worksChart: {
                chart: { 
                    type: "donut", 
                    height: 300 
                }, 
                dataLabels: {
                    enabled: false
                },
                labels: [
                    "Taking Class", 
                    "Lesson Discuss", 
                    "Lesson Discuss"
                ], 
                colors: [
                    "#4FCB8D", 
                    "#1765FD", 
                    "#FEC107",
                ], 
                legend: { 
                    show: !1 
                }, 
                plotOptions: { 
                    pie: { 
                        donut: { 
                            size: "60%" 
                        } 
                    } 
                } 
            },
        };
    },
}
</script>

<style lang="scss">
.works-stats-content {
	padding: 20px 28px !important;
	padding-bottom: 10px !important;
	margin-bottom: 20px !important;
	.works-chart {
		margin-bottom: 49px;
	}
    .apexcharts-canvas {
        margin: auto;
    }
}
.single-works {
	padding-left: 10px;
	margin-bottom: 20px;
	position: relative;
	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 100%;
		background-color: #1765fd;
		border-radius: 30px;
	}
	.title {
		font-size: 13px;
		font-weight: 500;
		letter-spacing: -0.26px;
		display: block;
		margin-bottom: 4px;
	}
	h4 {
		font-size: 14px;
		span {
			font-size: 11px;
			color: #BCC2CF;
			font-weight: 500;
		}
	}
	&.border-style-5c31d6 {
		&::before {
			background-color: #5c31d6;
		}
	}
	&.border-style-4fcb8d {
		&::before {
			background-color: #4fcb8d;
		}
	}
	&.border-style-fec107 {
		&::before {
			background-color: #fec107;
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .works-stats-content {
        .works-chart {
            margin-bottom: 30px;
        }
        .col-sm-4 {
            flex: 0 0 auto;
            width: 50%;
        }
    }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
    .works-stats-content {
        .col-sm-4 {
            flex: 0 0 auto;
            width: 33.33%;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .works-stats-content {
        .works-chart {
            margin-bottom: 30px;
        }
    }
}

/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {
    .works-stats-content {
        .col-lg-4 {
            &:nth-child(2) {
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
        }
        .works-chart {
            margin-bottom: 15px;
        }
    }
    .single-works {
        .title {
            font-size: 9px;
        }
        h4 {
            font-size: 9px;
        }
    }
}
</style>